import Layout from '@/layout/default'
const systemRounter = [
    // {
    //     path: '/system',
    //     component: Layout,
    //     name: 'system',
    //     meta: { title: '系统运维' },
    //     children: [{
    //         path: '/system/role',
    //         name: 'role',
    //         component: () =>
    //             import ('@/areas/systemmanage/views/role/RoleList.vue'),
    //         meta: { title: '角色管理', visiteType: '1', needAuth: true },


    //     }, {
    //         path: '/system/roletype',
    //         name: 'roletype',
    //         component: () =>
    //             import ('@/areas/systemmanage/views/role/RoleType.vue'),
    //         meta: { title: '角色类型', visiteType: '1', needAuth: true },


    //     }, {
    //         path: '/system/site',
    //         name: 'site',
    //         component: () =>
    //             import ('@/areas/systemmanage/views/site/SiteList.vue'),
    //         meta: { title: '站点管理', visiteType: '1', needAuth: true },


    //     }, {
    //         path: '/system/siteconfig',
    //         name: 'siteconfig',
    //         component: () =>
    //             import ('@/areas/systemmanage/views/site/SiteConfig.vue'),
    //         meta: { title: '站点配置', visiteType: '1', needAuth: true },


    //     }, {
    //         path: '/system/menu',
    //         name: 'menu',
    //         component: () =>
    //             import ('@/areas/systemmanage/views/menu/MenuList.vue'),
    //         meta: { title: '菜单管理', visiteType: '1', needAuth: true },
    //     }, {
    //         path: '/system/MyInfo',
    //         name: 'MyInfo',
    //         component: () =>
    //             import ('@/areas/systemmanage/views/user/MyInfo.vue'),
    //         meta: { title: '个人设置', visiteType: '1', needAuth: true },


    //     }, ]
    // },
    {
        path: '/maindata',
        component: Layout,
        name: 'maindata',
        meta: { title: '主数据' },
        children: [
            // {
            //     path: '/maindata/user',
            //     name: 'user',
            //     component: () =>
            //         import ('@/areas/systemmanage/views/user/UserList.vue'),
            //     meta: { title: '用户管理', visiteType: '1', needAuth: true },


            // }, {
            //     path: '/maindata/organization',
            //     name: 'organization',
            //     component: () =>
            //         import ('@/areas/systemmanage/views/organization/OrganizationList.vue'),
            //     meta: { title: '机构管理', visiteType: '1', needAuth: true },


            // }, {
            //     path: '/maindata/dictionary',
            //     name: 'dictionary',
            //     component: () =>
            //         import ('@/areas/systemmanage/views/dictionary/Dictionary.vue'),
            //     meta: { title: '数据字典', visiteType: '1', needAuth: true },
            // },
            {
                path: '/iframe',
                query: { url: 'https://www.baidu.com', needAuth: true },
                name: 'baidu',
                component: () =>
                    import ('@/components/Iframe/Page'),
                meta: { title: 'iframe内嵌', visiteType: '1', needAuth: true },
            },
            {
                path: 'https://www.baidu.com',

                meta: { title: '外链接', visiteType: '2', needAuth: true },
            }, {
                path: '/maindata/document',
                name: 'document',
                component: () =>
                    import ('@/views/document/Document.vue'),
                meta: { title: '文档管理', visiteType: '1', needAuth: true },
            },
        ]
    },
    {
        path: '/components',
        component: Layout,
        name: 'components',
        meta: { title: '组件展示' },
        children: [{
            path: '/components/table',
            name: 'table',
            component: () =>
                import ('@/views/componentsDisplay/table.vue'),
            meta: { title: '表格', visiteType: '1', needAuth: true },
        }, {
            path: '/components/form',
            name: 'form',
            component: () =>
                import ('@/views/componentsDisplay/form.vue'),
            meta: { title: '表单', visiteType: '1', needAuth: true },
        }, {
            path: '/components/input',
            name: 'input',
            component: () =>
                import ('@/views/componentsDisplay/input.vue'),
            meta: { title: '输入框', visiteType: '1', needAuth: true },
        }, {
            path: '/components/selectTree',
            name: 'selectTree',
            component: () =>
                import ('@/views/componentsDisplay/selectTree.vue'),
            meta: { title: '下拉树', visiteType: '1', needAuth: true },
        }, {
            path: '/components/tree',
            name: 'tree',
            component: () =>
                import ('@/views/componentsDisplay/tree.vue'),
            meta: { title: '树形', visiteType: '1', needAuth: true },
        }, {
            path: '/components/dialog',
            name: 'dialog',
            component: () =>
                import ('@/views/componentsDisplay/dialog.vue'),
            meta: { title: '弹窗', visiteType: '1', needAuth: true },
        }, {
            path: '/components/chart',
            name: 'chart',
            component: () =>
                import ('@/views/componentsDisplay/echart.vue'),
            meta: { title: '统计图', visiteType: '1', needAuth: true },
        }, {
            path: '/components/upload',
            name: 'upload',
            component: () =>
                import ('@/views/componentsDisplay/upload.vue'),
            meta: { title: '上传', visiteType: '1', needAuth: true },
        }, ]
    }
]
export default systemRounter


// WEBPACK FOOTER //
// ./src/areas/systemmanage/router.js